import { Dispatch, FC, SetStateAction, useContext, useMemo, useState } from 'react';
import createNamedContext from 'utils/createNamedContext';

export type MediaType = 'image' | 'video';

export interface MediaPreviewState {
  visible: boolean;
  type?: MediaType;
  files: File[];
}

export interface MediaPreviewContextValue {
  value: MediaPreviewState;
  setValue: Dispatch<SetStateAction<MediaPreviewState>>;
}

export const MediaPreviewContext = createNamedContext<MediaPreviewContextValue | null>(
  'MediaPreviewContext',
  null,
);

export const MediaPreviewProvider: FC = (props) => {
  const [value, setValue] = useState<MediaPreviewState>({
    visible: false,
    type: undefined,
    files: [],
  });

  return (
    <MediaPreviewContext.Provider
      value={useMemo(() => ({ value, setValue }), [value, setValue])}
      {...props}
    />
  );
};

export const useMediaPreviewContext = () => {
  const value = useContext(MediaPreviewContext);

  if (!value) {
    throw new Error(
      'useMediaPreviewContext hook should be used in a context of MediaPreviewProvider component',
    );
  }

  return value;
};

export const useMediaPreview = () => {
  return useMediaPreviewContext().value;
};

export const useSetMediaPreview = () => {
  return useMediaPreviewContext().setValue;
};
